export const mapIntentSelectStateToProps = ({ intents }) => ({ intents })

export const inputChangeEvent = 'input-change'
